module.exports = __webpack_public_path__ + "img/parteight_pic6.0f2fcef4.png";